import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageServiceObservablesService {

  public userEmail: string;

  constructor() {
    //do nothing
  }

  getUserFromStorage() {
    // for development and testing
    let currentUser;
    if (JSON.parse(localStorage.getItem('currentUser'))) {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    // this undefined error shouldn't show up if you are logged in,
    // but for testing and dev purposes we should just set it if
    // it is undefined
    if (currentUser === undefined) {
      this.userEmail = '';
    } else {
      this.userEmail = currentUser.username;
    }
    return this.userEmail;
  }

  setUserStorage(email: string, resp: any) {
    // for development and testing
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    currentUser.username = email;
    currentUser.id.id = resp.id;
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
  }

  getUserInfFromStorage() {
    let userInfo;
    if (JSON.parse(localStorage.getItem('userInfo'))) {
      userInfo = JSON.parse(localStorage.getItem('userInfo'));
    }
    return userInfo;
  }

  setUserInfo(user: any) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    userInfo.email = user.email;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  setCookie(email: string, name: string, remember: any, bioMetric: boolean) {
    const currentUser: any = {};
    currentUser.email = email;
    currentUser.name = name.replace('DEFAULT', '').replace('undefined', '');
    currentUser.date = new Date();
    if (bioMetric) {
      currentUser.bioMetric = bioMetric;
    }
    localStorage.setItem('rememberMe', JSON.stringify(currentUser));
  }

  getCookie() {
    const currentUser: any = JSON.parse(localStorage.getItem('rememberMe'));
    return currentUser;
  }

  deleteCookie() {
    localStorage.removeItem('rememberMe');
  }

  getBioPass() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser.id.token;
  }
}
